import { timer } from "rxjs";
import { Component, OnInit, input, inject } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { ErrorMessageService } from "@app/shared/services/material-error-message.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "material-form-input-with-copy",
    templateUrl: "./form-input-with-copy.component.html",
    styleUrls: ["./form-input-with-copy.component.scss"],
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
    ],
})
export class FormInputWithCopyComponent implements OnInit {
    private errorMessageService = inject(ErrorMessageService);

    readonly control = input<FormControl>(undefined);
    readonly title = input<string>(undefined);
    copyIconName = "file_copy";

    ngOnInit() {}

    getError() {
        return this.errorMessageService.getErrorMessageUsingFormControl(
            this.control()
        );
    }

    copy() {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = this.control().value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        try {
            document.execCommand("copy");
        } finally {
            this.copyIconName = "check";
            timer(600).subscribe(() => {
                this.copyIconName = "file_copy";
            });
        }
        document.body.removeChild(selBox);
    }
}
